import { Node } from '@tiptap/core';
import { mergeAttributes } from '@tiptap/core';
export const ProductInfo = Node.create({
    name: 'productInfo',
    group: 'block',
    atom: true,
    draggable: true,
    addAttributes() {
        return {
            description: {
                default: '',
                renderHTML(attrs) {
                    return { 'data-description': attrs.description };
                },
                parseHTML(element) {
                    return element.getAttribute('data-description') ?? '';
                },
            },
            link: {
                default: '',
                renderHTML(attrs) {
                    return { 'data-link': attrs.link };
                },
                parseHTML(element) {
                    return element.getAttribute('data-link') ?? '';
                },
            },
        };
    },
    addCommands() {
        return {
            setProductInfo: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-product-info',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-product-info', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=product-info.js.map